/*
var lastScrollTop = 0;

$(window).bind('scroll', function () {
/*
  if($.cookie("infoLista") == "hiden") {
    var numMore = $(".header__top").innerHeight();
  }else {
    var numMore = $(".info-bar__wrapper").innerHeight() + $(".header__top").innerHeight();
  }

*/
/*
  var numMore = $(".header__top").innerHeight();

  var num = $(".info-bar__wrapper").innerHeight();
  var padding = $(".header__sticky").innerHeight();
  if($(window).width() > 750) {
    if ($(window).scrollTop() > numMore) {
      $('.header__sticky').addClass('fixed');
      $('.main').css("padding-top", padding + "px");
    } else {
      $('.header__sticky').removeClass('fixed');
      $('.main').css("padding-top", "0px");
    }
  }else {
    if ($(window).scrollTop() > num) {
      $('.header__sticky').addClass('fixed');
      $('.main').css("padding-top", padding + "px");
    } else {
      $('.header__sticky').removeClass('fixed');
      $('.main').css("padding-top", "0px");
    }
  }

  if ($(window).scrollTop() > 500) {
    if ($('.header__sticky:hover').length == 0) {
      $(".header__sticky").addClass("hide");
    }
  }

  var st = $(this).scrollTop();
  if (st > lastScrollTop){
    // downscroll code
  } else {
    $(".header__sticky").removeClass("hide");
  }
  lastScrollTop = st;

});

/*if($(window).width() > 750) {
    $(".header__sticky").hover(function () {
        $("html").css({
            overflow: 'hidden',
            height: '100%',
            'scrollbar-gutter': 'stable'
        });
    }, function () {
        $("html").css({
            overflow: 'auto',
            height: 'auto'
        });
    });
}
*/
